function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 28,
    viewBox: "0 0 128 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cqws8nxrxa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154495",
    style: {
      fill: "none"
    },
    d: "M0 0h122.961v22.773H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6332"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154496",
    style: {
      fill: "none"
    },
    d: "M0 0h128v28H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6331"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154494",
    transform: "translate(3 3.494)",
    style: {
      fill: "#008ed1"
    },
    d: "M0 0h6.413v21.906H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6330"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6329",
    style: {
      clipPath: "url(#cqws8nxrxa)"
    },
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5952",
    d: "M16.827 0a10.7 10.7 0 0 1 7.907 3.353 11.046 11.046 0 0 1 3.3 8.024 11 11 0 0 1-3.32 8.075 11 11 0 0 1-8.075 3.322 10.972 10.972 0 0 1-8.059-3.339 10.977 10.977 0 0 1-3.337-8.058A10.885 10.885 0 0 1 8.6 3.305 11.287 11.287 0 0 1 16.827 0m-.191 6.387a4.51 4.51 0 0 0-3.385 1.464 4.915 4.915 0 0 0-1.4 3.525 4.916 4.916 0 0 0 1.406 3.53 4.66 4.66 0 0 0 6.769.008 4.918 4.918 0 0 0 1.393-3.538 4.92 4.92 0 0 0-1.393-3.536 4.522 4.522 0 0 0-3.392-1.454",
    transform: "translate(-.868)",
    style: {
      fill: "#b6c91e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5953",
    d: "M36.59 6.734V22.5h-6.414V6.734h-4.912V.592h16.223v6.142z",
    transform: "translate(-4.184 -.098)",
    style: {
      fill: "#008ed1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5954",
    d: "M55.663 19.273a4.923 4.923 0 0 0 3.039-.745 2.287 2.287 0 0 0 .941-1.869v-.334a2.222 2.222 0 0 0-.988-1.99 8.845 8.845 0 0 0-2.871-1.079q-1.367-.3-2.749-.637a8.824 8.824 0 0 1-2.492-1 5.325 5.325 0 0 1-1.808-1.808 5.8 5.8 0 0 1-.7-3.053v-.4a6.053 6.053 0 0 1 .4-2.081 5.485 5.485 0 0 1 1.307-1.99 6.989 6.989 0 0 1 2.416-1.5 10.192 10.192 0 0 1 3.717-.598 15.689 15.689 0 0 1 3.494.38 10.646 10.646 0 0 1 3.343 1.443l-1.823 3.009A7.985 7.985 0 0 0 58.4 3.912a11.221 11.221 0 0 0-2.461-.259 5.9 5.9 0 0 0-1.791.243 4 4 0 0 0-1.262.638 2.768 2.768 0 0 0-.744.851 1.923 1.923 0 0 0-.244.911v.365a2.013 2.013 0 0 0 .38 1.277 2.913 2.913 0 0 0 1.018.805 6.622 6.622 0 0 0 1.5.516q.865.2 1.837.41a15.662 15.662 0 0 1 3.267 1.049 7.74 7.74 0 0 1 2.127 1.413 4.731 4.731 0 0 1 1.155 1.747 6.032 6.032 0 0 1 .35 2.081v.4a6.448 6.448 0 0 1-.654 3.054 5.309 5.309 0 0 1-1.778 1.972 7.556 7.556 0 0 1-2.582 1.063 14.125 14.125 0 0 1-3.04.319 13.639 13.639 0 0 1-2.323-.2 14.908 14.908 0 0 1-2.144-.532 11.51 11.51 0 0 1-1.867-.805 9.912 9.912 0 0 1-1.5-.988l1.883-3.1a9.608 9.608 0 0 0 6.139 2.128",
    transform: "translate(-7.889 -.031)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5955",
    d: "M69.186.59h8.265a10.785 10.785 0 0 1 3.389.471 6.352 6.352 0 0 1 2.324 1.306 5.16 5.16 0 0 1 1.352 1.99 6.933 6.933 0 0 1 .441 2.492v.638a7.069 7.069 0 0 1-.456 2.537 5.615 5.615 0 0 1-1.4 2.1 6.9 6.9 0 0 1-2.34 1.428 9.29 9.29 0 0 1-3.313.532h-4.373V22.5h-3.889zm3.889 3.251V10.8h3.859a5.373 5.373 0 0 0 3.008-.729 2.945 2.945 0 0 0 1.095-2.644V6.88a3.487 3.487 0 0 0-.274-1.489 2.306 2.306 0 0 0-.775-.926 3.117 3.117 0 0 0-1.2-.486 7.874 7.874 0 0 0-1.52-.137z",
    transform: "translate(-11.457 -.098)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5956",
    d: "M104.439 22.5h-4.224l-2.128-6.016H90.7L88.547 22.5h-3.98L92.709.59H96.2zm-12.61-9.266h5.135l-1.489-4.47c-.264-.73-.471-1.342-.622-1.839s-.31-1.008-.471-1.534q-.123.457-.229.82c-.07.244-.146.491-.227.745l-.259.805c-.092.283-.208.618-.349 1z",
    transform: "translate(-14.004 -.098)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5957",
    d: "M116.92.188a13.926 13.926 0 0 1 4.08.547 10.489 10.489 0 0 1 3.45 1.885l-2.1 2.977a6.979 6.979 0 0 0-2.643-1.473 10.833 10.833 0 0 0-2.8-.35 6.468 6.468 0 0 0-1.915.29 3.876 3.876 0 0 0-1.671 1.048 5.618 5.618 0 0 0-1.186 2.066 10.344 10.344 0 0 0-.456 3.343v2.248a8.957 8.957 0 0 0 .426 2.949 5.484 5.484 0 0 0 1.139 1.976 4.3 4.3 0 0 0 1.655 1.107 5.626 5.626 0 0 0 1.977.35 10.946 10.946 0 0 0 3.124-.472 6.692 6.692 0 0 0 2.9-1.809l2.066 2.978a8.44 8.44 0 0 1-2.052 1.535 12.3 12.3 0 0 1-2.141.881 10.545 10.545 0 0 1-2.1.41q-1.033.091-1.944.092a11.209 11.209 0 0 1-3.419-.517 7.571 7.571 0 0 1-2.856-1.64 8.015 8.015 0 0 1-1.961-2.854 10.817 10.817 0 0 1-.728-4.2V9.638a11.363 11.363 0 0 1 .714-4.239 8.123 8.123 0 0 1 1.96-2.946 7.741 7.741 0 0 1 2.9-1.718 11.336 11.336 0 0 1 3.57-.547",
    transform: "translate(-17.847 -.031)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5958",
    d: "M144.312.59v3.221h-10.24v5.9h9.6v3.16h-9.6v6.412h10.453V22.5h-14.313V.59z",
    transform: "translate(-21.563 -.098)",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d6cb3b173e012d89f210ec965777a14.svg";
export { ForwardRef as ReactComponent };